const APP_ROUTES = {
    LOGIN: '/login',
    HOME: '/home',
    LOAD: '/carga',
    REPORT: '/reporte',
    DELETED: '/eliminadas',
    BALANCE: '/saldos'
}

export default APP_ROUTES